import React from "react";
import { connect } from 'react-redux';
import ProductVariant from '../../Components/ProductVariant/ProductVariant';
import ProductVariantContainer from '@configuratorware/configurator-frontendgui/App/Shared/Containers/ProductVariant'
const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
   
});

export interface ProductVariantProps {
    ProductVariantComponent: any,
    ProgressComponent: any,
    getPreviewImages: () => void,
    renderPreviewImagesForCheckout: boolean,
    amountData: [],
    title: string,
    image: string | null
}

export default connect(mapStateToProps, mapDispatchToProps)((props: ProductVariantProps) =>
    <ProductVariantContainer
        {...props}
        Component={ProductVariant}
    />
);